import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 36, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, description, light = false, align = "center", script }) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <Reveal className={`flex flex-col ${alignCls}`}>
      <div className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}>
        <span className="hairline" />
        <span className={light ? "eyebrow-light" : "eyebrow"}>{eyebrow}</span>
        <span className="hairline" />
      </div>
      <h2
        className={`mt-5 font-serif text-3xl font-medium leading-tight tracking-tight sm:text-4xl lg:text-5xl ${
          light ? "text-stone-100" : "text-stone-900"
        }`}
      >
        {title}
      </h2>
      {script && (
        <p className={`mt-3 font-script text-2xl sm:text-3xl ${light ? "text-gold-soft/90" : "text-gold-dark/80"}`}>
          {script}
        </p>
      )}
      {description && (
        <p className={`mt-5 max-w-2xl text-base leading-relaxed sm:text-lg ${light ? "text-stone-400" : "text-stone-600"}`}>
          {description}
        </p>
      )}
    </Reveal>
  );
}
